<template>
	<wt-selector class="pt-selector" :options="options" v-model="Value" :clearable="true" :props="props"></wt-selector>
</template>
<script>
import { getGenderOptions } from '@/utils/formUtils'
export default {
  name: 'gender-selector',
  props: {
    value: {
      type: String
    },
    type: {
      type: String,
      default: 'gender'// title称谓
    }
  },
  data () {
    return {
      Value: this.value ? this.value : '',
      options: [],
      props: {
        label: 'value',
        value: 'key'
      }
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getGenderOptions,
    getOptions () {
      if (this.type === 'title') {
        getGenderOptions().map(item => {
          if (item.value === '男') {
            item.value = '先生'
          } else if (item.value === '女') {
            item.value = '女士'
          }
        })
      }
      this.options = getGenderOptions()
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
<style lange="less">
.pt-selector {
  width: 100%;
}
</style>
